import { AppDispatch } from "@/app/store/store";
import { baseBuild } from "@/core/services/network/config/baseBuild";
import { storageBuild } from "@/core/services/storage/config/storage.build";
import { PhysicalStoreAdapter } from "@/shared/features/physical-store/infra/adapters/physicalStore.adapter";
import { PincodeAdapter } from "../infra/adapters/pincode.adapter";
import { PincodeService } from "../application/services/pincodeService";

export function pincodeBuild(dispatch: AppDispatch) {
  const { repo: storageRepo } = storageBuild();
  const physicalStoreRepo = new PhysicalStoreAdapter(dispatch);

  return baseBuild(
    (d) => new PincodeAdapter(d),
    (repo) => PincodeService(repo, storageRepo, physicalStoreRepo),
    dispatch
  );
}